import { useState } from "react"
import { KeyedMutator } from "swr"

import {
    SUPPORT_REFER,
    SUPPORT_REFER_HELP_DESK,
} from "../../../../errors/errorMessages"
import { parseErrorAsObj } from "../../../../errors/errorProcessors"
import { snackbar } from "../../../../utils/general/generalUtils"
import { deleteClientProtected } from "../../clients/clients"
import { TUsersOutput } from "../../mappers/adminPortal/activeUsersMapper"
import { DELETE_USER } from "../../urls/private"

type IDeleteUser = {
    deleteUser: () => Promise<void>
    isLoading: boolean
}

/**
 * Mutate relevent list users key on sucessfull submission
 * This hook exposes a fucntion for deleting a single user
 * @param {string} userName - is the congnito user name ID
 * @returns {IDeleteUser} - delete function and loading state
 */
const useDeleteUser = (
    userName: string,
    fullName: string,
    mutate: KeyedMutator<TUsersOutput>
): IDeleteUser => {
    const [isLoading, setIsLoading] = useState(false)
    const deleteUser = async (): Promise<void> => {
        try {
            setIsLoading(true)
            await deleteClientProtected(DELETE_USER(userName))
            snackbar(`${fullName} successfully deleted`, "success")
            mutate()
        } catch (err) {
            const errorObj = parseErrorAsObj(err)

            let errorMsg
            if (errorObj?.code === 403) {
                errorMsg = `${errorObj?.message}. Please ${SUPPORT_REFER_HELP_DESK}`
            } else {
                errorMsg = `Unable to delete ${fullName}. Please try again. ${SUPPORT_REFER}`
            }

            snackbar(errorMsg, "warning")
        } finally {
            setIsLoading(false)
        }
    }

    return {
        deleteUser,
        isLoading,
    }
}

export default useDeleteUser
